import { Avatar, Button, Grid, Typography } from '@mui/material';
import MOBILE_SIDEPANEL_CLASSES from './mobileSidePanelClasses';
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'

import { isEmpty } from 'lodash'
import { withTranslation } from "react-i18next"
import { DateFnsFormats, formatAs, getAsLongDateTime, getAsStartAndEndTimeFormat, removeBrowserTimezoneConversion } from '../../../../../common-client2/src/services/ukgDateTime'
import { getValidationFailureMessages } from '../../../../Utils/ValidationFailureFormatter'
import CollapsableCard from '../../../../../common/components/UI/CollapsableCard/CollapsableCard'
import ReactSelect from "../../../../../common/components/UI/Select/ReactSelect"
import { formatProposalData, formatProposalDataWithCustomName } from '../../../../auxilaries'
import { RequestSource, RequestStatus, RequestSubtypes, RequestTypes, ShiftSegmentTypeName, TypeOfPeriod } from '../../../../Enums'
import { isDatetimeInRequestPeriod, isProbationValidForShifts, isSegmentTagValidForShifts, isValidSettingAfterShiftStart, isWorkRuleValidForShifts } from '../../../../utils'
import { updateEmployeeDashboardData, updateLoading, updateSidePanelData, updateSnackbar } from '../../../actions'
import { clearMobileOfferForm, updateMobileOfferForm, updateMobileView } from '../../../actions/mobileActions'
import { ConfirmWithMessageContent, PartialIcon, ProposalCard, ValidationErrorPanel } from '../../../components/core'
import { SidePanelDetails } from '../../SidePanel'
import AssignmentSelector from '../../Utils/AssignmentSelector'
import AvailableTimeOffRequest from '../../Utils/AvailableTimeOffRequest'
import {
    handleDeclineShiftSwap,
    handleDeclineToCover,
    handleRejectProposal,
    handleRetractRequestOpenShift,
    handleRetractRequestVTO,
    handleRetractShiftOffer, handleRetractShiftRequest,
    handleRetractShiftSwapProposal,
    handleRetractShiftToSwapOffer
} from '../../Utils/handlers'
import { buildDailyShiftSegments, generateVTOInformation } from '../../Utils/uiGenerators'
import ShiftCard from '../shiftCard'
import './shiftDetails.scss'

/**
 * @param {string} date1
 * @param {string} date2
 */
const sortDatePreferences = (date1, date2) => new Date(date1) - new Date(date2);

class ShiftDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            expands: {
                "proposed": 0,
                "offered": 0,
                "history": 0,
                "recipients": 0,
                "preferredDates": 0
            },
            showRetractConfirmation: false,
            selectedAssignmentId: null,
        }
    }

    getValidAssignments = () => {
        const { formData } = this.props;
        if (!formData || formData.type !== RequestTypes.toCover) return [];
        const list = formData.raw?.validAssignments;
        return Array.isArray(list) ? list : [];
    }

    getEffectiveAssignmentId = () => {
        const validAssignments = this.getValidAssignments();
        if (validAssignments.length === 0) return null;
        if (validAssignments.length === 1) return validAssignments[0].assignmentId;
        return this.state.selectedAssignmentId;
    }

    isValidAssignmentSelectionMissing = () => {
        const validAssignments = this.getValidAssignments();
        if (validAssignments.length <= 1) return false;
        return !this.state.selectedAssignmentId;
    }

    handleSelectedAssignmentChange = (selectedAssignmentId) => {
        this.setState({ selectedAssignmentId });
    }

    renderValidAssignmentSelect = () => {
        const { t } = this.props;
        const validAssignments = this.getValidAssignments();
        if (validAssignments.length === 0) return null;
        return (
            <Grid item xs={12} style={{ padding: '10px 15px' }}>
                <AssignmentSelector
                    validAssignments={validAssignments}
                    selectedAssignmentId={this.state.selectedAssignmentId}
                    onChange={this.handleSelectedAssignmentChange}
                    labelText={t('billboard.selectAssignment')}
                    placeholder={t('billboard.selectAssignmentPlaceholder')}
                />
            </Grid>
        );
    }

    filterManagerSettings = () => {
        const { managerSettings, formData } = this.props;
        let settings = Object.assign([], managerSettings);
        for (const shift of formData.shifts) {
            settings = settings.filter(setting =>
                setting.isVisible
                && setting.type !== RequestTypes.openShift
                && setting.type !== RequestTypes.voluntaryTimeOff
                && isProbationValidForShifts(setting, formData.shifts)
                && (setting.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever
                    || moment.utc().isBetween(moment.utc(setting.toCoverPeriod_StartDate), moment.utc(setting.toCoverPeriod_EndDate), null, '[]'))
                && isDatetimeInRequestPeriod(shift.startDateTime, setting)
                && isWorkRuleValidForShifts(setting, [shift])
                && isSegmentTagValidForShifts(setting, [shift])
            )

            const currentTime = moment.utc().add(moment().utcOffset(), 'm').toISOString();
            const hasShiftStarted = shift.startDateTime < currentTime;
            const hasShiftEnded = shift.endDateTime < currentTime;
            const isShiftInProgress = hasShiftStarted && !hasShiftEnded;
            if (isShiftInProgress) {
                const shiftStartTime = new Date(shift.startDateTime);
                const validManagerSettingsAfterShiftStart = managerSettings.filter(x => isValidSettingAfterShiftStart(x, shiftStartTime));
                const validManagerSettingsAfterShiftStartIds = validManagerSettingsAfterShiftStart.map(x => x.id);
                settings = settings.filter(x => validManagerSettingsAfterShiftStartIds.includes(x.id));
            }
        }
        return settings
    }

    handleNextView = () => {
        const { updateSidePanelView, updateMobileOfferForm, formData, updateLoading, updateSnackbar } = this.props
        if (formData.type === -1) {
            const validationByAssignmentId = formData.managerSetting.workedHoursValidationByAssignmentId || {}
            const validation = (formData.shifts || [])
                .map(shift => validationByAssignmentId[shift.assignmentId] || validationByAssignmentId[""])
                .find(v => v && !v.isValid)
            if (validation) {
                updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: `Worked hours requirements not met. Required time worked between ${formatAs(validation.startDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
                    and ${formatAs(validation.endDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)} is ${validation.requiredHours} hours. Hours worked during that period: ${validation.workedHours}`,
                    openSnackbar: true
                })
                return
            }
            updateMobileOfferForm({
                partialDates: {
                    startDate: moment.utc(formData.shifts[0].startDateTime),
                    endDate: moment.utc(formData.shifts[0].endDateTime),
                }
            });
            if ((formData.managerSetting.type === RequestTypes.toCover || formData.managerSetting.type === RequestTypes.shiftSwap) && formData.managerSetting.isPartialShiftEnabled) {
                updateSidePanelView('PartialShift')
            }
            else {
                updateSidePanelView('SendTo')
            }
        } else if (formData.type === RequestTypes.shiftSwap) {
            updateLoading(true)
            updateSidePanelView('ShiftPicker')
        }
    }

    showRetractConfirmation = () => {
        this.setState({
            showRetractConfirmation: true
        });
    }

    hideRetractConfirmation = () => {
        this.setState({
            showRetractConfirmation: false
        });
    }

    handleConfirmRetract = async () => {
        const { mobileView, updateMobileView, clearMobileOfferForm, formData, person } = this.props;

        switch (formData.type) {
            case RequestTypes.toCover:
                if (formData.source === RequestSource.Offerer) {
                    // handleRetractShiftOffer expects the full offer object
                    await handleRetractShiftOffer.bind(this)(formData);
                } else {
                    // handleRetractShiftRequest expects the full offer object
                    await handleRetractShiftRequest.bind(this)(formData);
                }
                break;
            case RequestTypes.shiftSwap:
                if (formData.source === RequestSource.Offerer) {
                    // handleRetractShiftToSwapOffer expects the full offer object
                    await handleRetractShiftToSwapOffer.bind(this)(formData);
                } else {
                    // handleRetractShiftSwapProposal expects (offer, proposalId)
                    const found = formData.proposals?.find(proposal =>
                        proposal.proposalEmployeeId === person.currentEmployeeId &&
                        (proposal.status === RequestStatus.Offered || proposal.status === RequestStatus.Submitted)
                    );
                    if (found) {
                        await handleRetractShiftSwapProposal.bind(this)(formData, found.proposalId);
                    }
                }
                break;
            case RequestTypes.openShift:
                // handleRetractRequestOpenShift expects just the requestId
                await handleRetractRequestOpenShift.bind(this)(formData.offerId);
                break;
            case RequestTypes.voluntaryTimeOff:
                // handleRetractRequestVTO expects just the offerId
                await handleRetractRequestVTO.bind(this)(formData.offerId);
                break;
            default:
                console.warn('Unknown retract scenario for formData type:', formData.type);
                break;
        }

        this.hideRetractConfirmation();
        updateMobileView(mobileView.previous);
        clearMobileOfferForm();
    }

    handleSelectManagerSetting = (target, value) => {
        const { formData, updateSidePanelData } = this.props;
        if (formData.managerSetting?.aggregateRootId === value.aggregateRootId) {
            return;
        }

        updateSidePanelData({ timeOffRequest: null, timeOffRequestError: null });

        this.handleSelectUpdateForm(target, value);
    }

    handleSelectUpdateForm = (target, value) => {
        const { updateMobileOfferForm } = this.props;
        updateMobileOfferForm({ [target]: value })
    }

    shiftBuilder = (shifts, title, expandKey, isPartial) => {
        const { classes } = this.props
        const { expands } = this.state
        return (
            <Grid item xs={12} className={classes.segments}>
                <CollapsableCard
                    title={title}
                    expanded={expands[expandKey]}
                    handleCollapse={() => {
                        expands[expandKey] = !expands[expandKey]
                        this.setState({ expands: expands })
                    }}
                >
                    {
                        shifts.map(shift => {
                            let segment = shift.segments.find(x => x.segmentTypeRef.qualifier !== ShiftSegmentTypeName.BREAK_SEGMENT);
                            let primaryJob = segment ? segment.shortOrgJobPath : null;
                            return (
                                <ShiftCard
                                    color={0}
                                    shiftType={null}
                                    startDate={shift.startDateTime}
                                    endDate={shift.endDateTime}
                                    orgJob={primaryJob}
                                    isPartial={isPartial}
                                    shiftTemplateLabel={shift.label}
                                    assignmentName={shift.assignmentName}
                                />
                            );
                        })
                    }
                </CollapsableCard>
            </Grid>
        )
    }

    renderSegments = (shift) => {
        const { classes } = this.props
        return (
            <Grid item xs={12} className={classes.segments}>
                {shift.assignmentName && (
                    <Typography variant={'body2'} gutterBottom>
                        {`Assignment: ${shift.assignmentName}`}
                    </Typography>
                )}
                <Typography variant={'h6'}>Segments</Typography>
                {buildDailyShiftSegments(shift)}
            </Grid>
        )
    }

    renderAssignmentSelector = () => {
        const { formData, updateMobileOfferForm, t } = this.props;
        if (formData.type !== RequestTypes.openShift || formData.source !== RequestSource.Requester) {
            return null;
        }
        const rawOpenShift = Array.isArray(formData.raw) ? formData.raw[0] : formData.raw;
        const validAssignments = rawOpenShift?.validAssignments || [];
        if (validAssignments.length === 0) {
            return null;
        }
        return (
            <Grid item xs={12} style={{ padding: '10px 15px' }}>
                <Typography variant='subtitle2' style={{ fontWeight: 'bold', marginBottom: 8 }}>
                    {t('billboard.selectAssignment')}
                </Typography>
                <AssignmentSelector
                    validAssignments={validAssignments}
                    selectedAssignmentId={formData.selectedAssignmentId}
                    onChange={(selectedAssignmentId) => updateMobileOfferForm({ selectedAssignmentId })}
                    labelText={t('billboard.selectAssignment')}
                    placeholder={t('billboard.selectAssignmentPlaceholder')}
                />
            </Grid>
        );
    }



    generateSidePanelSubmitButtons = () => {
        const { classes, person, formData, mobileView, updateMobileView, clearMobileOfferForm, updateSidePanelView, updateMobileOfferForm, sidePanelData } = this.props;
        let button = '';
        switch (formData.type) {
            case -1:
                button =
                    <Grid item xs={12} style={{ padding: '5px' }}>
                        <Button fullWidth disabled={isEmpty(formData.managerSetting)} className={classes.primaryButton} onClick={() => this.handleNextView()}>
                            Next
                        </Button>
                    </Grid>
                break;
            case RequestTypes.toCover:
                switch (formData.status) {
                    case RequestStatus.Offered:
                        if (formData.source === RequestSource.Offerer) {
                            button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => {
                                this.showRetractConfirmation();
                            }}>
                                <Typography className={classes.SideBarSubmitText}>Retract offer</Typography>
                            </Button>
                        } else {
                            const isAssignmentMissing = this.isValidAssignmentSelectionMissing();
                            const isAcceptDisabled = !formData.isValid || isAssignmentMissing;
                            const acceptButtonClass = isAcceptDisabled ? classes.buttonDisabled : classes.primaryButton;
                            button =
                                <Grid container spacing={2}>
                                    <Grid item xs={formData.isPrivate ? 6 : 12}>
                                        <Button fullWidth disabled={isAcceptDisabled} className={acceptButtonClass} onClick={() => {
                                            updateMobileOfferForm({ assignmentId: this.getEffectiveAssignmentId() });
                                            updateSidePanelView('CommentToManager');
                                        }}>
                                            <Typography className={classes.SidePanelButtonText}>Accept request</Typography>
                                        </Button>
                                    </Grid>
                                    {formData.isPrivate ? <Grid item xs={6}>
                                        <Button mt={1} fullWidth className={classes.primaryButton} onClick={() => {
                                            handleDeclineToCover.bind(this)(formData.offerId)
                                            updateMobileView(mobileView.previous)
                                            clearMobileOfferForm()
                                        }}>
                                            <Typography className={classes.SidePanelButtonText}>Decline offer</Typography>
                                        </Button>
                                    </Grid> : null}
                                </Grid>
                        }
                        break;
                    case RequestStatus.Submitted:
                    case RequestStatus.Pending:
                        if (formData.source === RequestSource.Offerer) {
                            button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled}
                                onClick={() => {
                                    this.showRetractConfirmation();
                                }}
                            >
                                <Typography className={classes.SideBarSubmitText}>Retract offer</Typography>
                            </Button>
                        } else {
                            button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => {
                                this.showRetractConfirmation();
                            }}>
                                <Typography className={classes.SideBarSubmitText}>Retract request</Typography>
                            </Button>
                        }
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.shiftSwap:
                switch (formData.status) {
                    case RequestStatus.Offered:
                        if (formData.source === RequestSource.Offerer) {//mySwapOffers
                            button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => {
                                this.showRetractConfirmation();
                            }}>
                                <Typography className={classes.SideBarSubmitText}>Retract offer</Typography>
                            </Button>
                        } else {//available offer, myProposals
                            if (formData.isAvailableOffer
                                || (formData.raw.isPrivate
                                    && !formData.raw.isProposedByOfferer
                                    && formData.raw.proposals.every(x => ![RequestStatus.Offered, RequestStatus.Submitted, RequestStatus.Pending].includes(x.status)))) {
                                const isNextDisabled = !formData.raw.isSkipValidation && !formData.isValid;
                                button =
                                    <Grid container spacing={2}>
                                        <Grid item xs={formData.isPrivate ? 6 : 12}>
                                            <Button fullWidth disabled={isNextDisabled} className={isNextDisabled ? classes.buttonDisabled : classes.primaryButton}
                                                onClick={() => this.handleNextView()}
                                            >
                                                Next
                                            </Button>
                                        </Grid>
                                        {formData.isPrivate ? <Grid item xs={6}>
                                            <Button mt={1} fullWidth className={classes.primaryButton} onClick={() => {
                                                handleDeclineShiftSwap.bind(this)(formData.offerId)
                                                updateMobileView(mobileView.previous)
                                                clearMobileOfferForm()
                                            }}>
                                                <Typography className={classes.SidePanelButtonText}>Decline offer</Typography>
                                            </Button>
                                        </Grid> : null}
                                    </Grid>
                            }
                            else if (formData.raw.isProposedByOfferer && formData.raw.proposals.some(x => x.status === RequestStatus.Offered)) {
                                button =
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled}
                                                onClick={() => updateSidePanelView('CommentToManager')}
                                            >
                                                <Typography className={classes.SidePanelButtonText}>Confirm offer</Typography>
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button mt={1} fullWidth className={classes.primaryButton} onClick={() => {
                                                handleDeclineShiftSwap.bind(this)(formData.offerId)
                                                updateMobileView(mobileView.previous)
                                                clearMobileOfferForm()
                                            }}>
                                                <Typography className={classes.SidePanelButtonText}>Decline offer</Typography>
                                            </Button>
                                        </Grid>
                                    </Grid>
                            }
                            else {
                                let proposalOfInterest = formData.proposals ? formData.proposals.slice(-1) : undefined

                                let found = proposalOfInterest?.find((proposal) => (
                                    proposal.proposalEmployeeId === person.currentEmployeeId
                                    && (+proposal.status) !== RequestStatus.OfferRetracted
                                    && (+proposal.status) !== RequestStatus.AutoRetracted
                                ));

                                if (found) {
                                    if (found.status === RequestStatus.Offered || found.status === RequestStatus.Submitted) {
                                        button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled}
                                            onClick={() => {
                                                this.showRetractConfirmation();
                                            }}>
                                            <Typography className={classes.SideBarSubmitText}>Retract proposal</Typography>
                                        </Button>
                                    }
                                }
                            }
                        }
                        break;
                    case RequestStatus.Submitted:
                    case RequestStatus.Pending:
                        if (formData.source === RequestSource.Offerer) {
                            button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => {
                                this.showRetractConfirmation();
                            }}>
                                <Typography className={classes.SideBarSubmitText}>Retract offer</Typography>
                            </Button>
                        } else {
                            button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled}
                                onClick={() => {
                                    this.showRetractConfirmation();
                                }}
                            >
                                <Typography className={classes.SideBarSubmitText}>Retract proposal</Typography>
                            </Button>
                        }
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
                if (formData.source === RequestSource.Requester) {
                    const rawOpenShift = Array.isArray(formData.raw) ? formData.raw[0] : formData.raw;
                    const validAssignments = rawOpenShift?.validAssignments || [];
                    const isAssignmentSelectionRequired = validAssignments.length > 1 && !formData.selectedAssignmentId;
                    if (formData.managerSetting.isPartialShiftEnabled) {
                        button = <Button fullWidth disabled={isAssignmentSelectionRequired} className={isAssignmentSelectionRequired ? classes.buttonDisabled : classes.primaryButton} onClick={() => {
                            updateMobileOfferForm({
                                partialDates: {
                                    startDate: moment.utc(formData.shifts[0].startDateTime),
                                    endDate: moment.utc(formData.shifts[0].endDateTime),
                                }
                            });
                            updateSidePanelView('PartialShift')
                        }}
                        >
                            Next
                        </Button>
                        break;
                    }
                    const isSignUp = formData.managerSetting.requestSubtype === RequestSubtypes.signUp;
                    button = <Button fullWidth disabled={isAssignmentSelectionRequired} className={isAssignmentSelectionRequired ? classes.buttonDisabled : classes.primaryButton} onClick={() => updateSidePanelView('CommentToManager')}>
                        <Typography className={classes.SidePanelButtonText}>{isSignUp ? 'Sign up' : ' Submit request'}</Typography>
                    </Button>
                } else {
                    let statuses = [RequestStatus.Submitted, RequestStatus.Pending]
                    if (statuses.includes(formData.status)) {
                        button = <Button fullWidth className={classes.primaryButton} onClick={() => {
                            this.showRetractConfirmation();
                        }}>
                            <Typography className={classes.SidePanelButtonText}>Retract request</Typography>
                        </Button>
                    }
                }
                break;
            case RequestTypes.voluntaryTimeOff:
                if (formData.source === RequestSource.Requester) {
                    // Show partial shift selection if enabled and VTO type is TimePeriod (2)
                    if (formData.managerSetting.isPartialShiftEnabled && formData.managerSetting.voluntaryTimeOffType === 2) {
                        button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => {
                            updateMobileOfferForm({
                                partialDates: {
                                    isPartial: false,
                                    startDate: moment.utc(formData.raw.startDate),
                                    endDate: moment.utc(formData.raw.endDate),
                                }
                            });
                            updateSidePanelView('PartialShift')
                        }}>
                            <Typography className={classes.SidePanelButtonText}>Next</Typography>
                        </Button>
                        break;
                    }
                    button = <Button fullWidth disabled={!formData.isValid} style={{ padding: '10px 20px' }} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => updateSidePanelView('CommentToManager')}>
                        <Typography className={classes.SidePanelButtonText}>Sign up</Typography>
                    </Button>
                } else {
                    let statuses = [RequestStatus.Submitted, RequestStatus.Pending]
                    if (statuses.includes(formData.status)) {
                        button = <Button fullWidth disabled={!formData.isValid} className={formData.isValid ? classes.primaryButton : classes.buttonDisabled} onClick={() => {
                            this.showRetractConfirmation();
                        }}>
                            <Typography className={classes.SidePanelButtonText}>Retract request</Typography>
                        </Button>
                    }
                }
                break;
            default:
                break;
        }
        return button;
    }

    renderOfferOwnership = (employeeName) => {
        const { classes } = this.props
        return (
            <Grid container className={classes.ownerSection}>
                <Grid item xs={2}><Avatar alt={`${employeeName}`} /></Grid>
                <Grid item xs={10} className={classes.shiftInfoHeaderEmployeeNameWrapper}>
                    <Typography component='div' className={classes.shiftInfoHeaderEmployeeName} >{employeeName}</Typography>
                </Grid>
            </Grid>
        )
    }

    renderRecipients = () => {
        const { classes, formData } = this.props;
        const { expands } = this.state;

        if (formData.source !== RequestSource.Offerer) {
            return;
        }
        //let employeesToList = privateOffer ? privateOffer.employeesToList : [{name: 'Sent to billboard'}]
        let employeesToList = (formData.raw.employeesToList && formData.raw.employeesToList.length) ? formData.raw.employeesToList : [{ name: 'Sent to billboard' }];

        return (employeesToList.length > 0 ?
            <Grid item xs={12} className={classes.segments}>
                <CollapsableCard
                    title={"Recipients"}
                    expanded={expands["recipients"]}
                    handleCollapse={() => {
                        expands["recipients"] = !expands["recipients"]
                        this.setState({ expands: expands })
                    }}
                >
                    {employeesToList.map(ee => {
                        return <Typography className={classes.recipientNameStyle}>{ee.name}</Typography>
                    })}
                </CollapsableCard>
            </Grid> : null
        )
    }

    renderHistory = (historyToUse = []) => {
        const { classes, formData, managerSettingNames, t } = this.props;
        const { expands } = this.state;

        let historyToDisplay = historyToUse.length > 0 ? historyToUse : formData.history;

        return (historyToDisplay.length > 0 ?
            <Grid item xs={12} className={classes.segments}>
                <CollapsableCard
                    title={"History"}
                    expanded={expands["history"]}
                    handleCollapse={() => {
                        expands["history"] = !expands["history"];
                        this.setState({ expands: expands })
                    }}
                >
                    {
                        historyToDisplay.map(item => {
                            const failureMessages = getValidationFailureMessages(item, this.props.t);
                            const hasValidationFailures = failureMessages.length > 0;

                            return (
                                <div
                                    key={'historyLog' + item.offerId}
                                    className={classes.historyItemContainer}
                                    style={{
                                        border: hasValidationFailures ? '2px solid #f44336' : 'none',
                                        borderRadius: hasValidationFailures ? '4px' : '0',
                                        backgroundColor: hasValidationFailures ? '#ffebee' : 'transparent',
                                        padding: hasValidationFailures ? '8px' : '0'
                                    }}
                                >
                                    <div className={classes.historyLogFirst}>
                                        <span className={classes.historyLogName}>{item.employeeName} </span>
                                        <span>{item.status} </span>
                                        <span className={classes.historyLogshiftTime}>{managerSettingNames[item.managerSettingId]}</span>
                                    </div>
                                    <div className={classes.historyLogDate}>{formatAs(item.dateLogged, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)}</div>
                                    {!!item.message && <>
                                        <span className={classes.historyLogName}>{`${item.employeeName} commented "${item.message}"`} </span>
                                    </>}

                                    {hasValidationFailures && (
                                        <div style={{ marginTop: '8px', color: '#d32f2f' }}>
                                            <div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
                                                {this.props.t('validationFailureDetails.historyTitle')}
                                            </div>
                                            <ul style={{ margin: '0', paddingLeft: '16px', fontSize: '11px' }}>
                                                {failureMessages.map((message, failureIndex) => (
                                                    <li key={`validation-${item.offerId}-${failureIndex}`} style={{ marginBottom: '2px' }}>
                                                        {message}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            )
                        })
                    }
                </CollapsableCard>
            </Grid> : null
        )
    }

    renderDetails = () => {
        const { classes, formData } = this.props;
        const { expands } = this.state;

        return (
            <Grid item xs={12} className={classes.segments}>
                <CollapsableCard
                    title={"Details"}
                    expanded={expands["details"]}
                    handleCollapse={() => {
                        expands["details"] = !expands["details"];
                        this.setState({ expands: expands })
                    }}
                >
                    <SidePanelDetails
                        withHeader={false}
                        isShowManagerMessage
                        managerMessage={formData.details}
                    />
                </CollapsableCard>
            </Grid>
        )
    }

    renderPreferredDates = () => {
        const { classes, formData } = this.props;
        const { expands } = this.state;
        const sortedPreferences = formData.raw.datePreferences.sort(sortDatePreferences);

        return (formData.raw && formData.raw.datePreferences && formData.raw.datePreferences.length > 0 ?
            <Grid item xs={12} className={classes.segments}>
                <CollapsableCard
                    title={"Date preferences"}
                    expanded={expands["preferredDates"]}
                    handleCollapse={() => {
                        expands["preferredDates"] = !expands["preferredDates"]
                        this.setState({ expands: expands })
                    }}
                >
                    {
                        sortedPreferences.map((date) => {
                            return (
                                <Typography className={classes.recipientNameStyle}>
                                    {formatAs(removeBrowserTimezoneConversion(date), DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
                                </Typography>
                            )
                        })
                    }
                </CollapsableCard>
            </Grid> : null
        )
    }

    renderValidationDetails = () => {
        const { classes } = this.props;
        const { rawValidationDetails, statusValidationDetails } = this.props.formData;

        let validationErrors = rawValidationDetails != null && rawValidationDetails !== undefined && rawValidationDetails.length > 0 ? rawValidationDetails.filter(x => !x.isValid) : [];
        let statusValidationErrors = statusValidationDetails != null && statusValidationDetails !== undefined && statusValidationDetails.length > 0 ? statusValidationDetails.filter(x => !x.isValid) : [];

        if (validationErrors.length < 1 && statusValidationErrors.length < 1) {
            return;
        }

        return ((validationErrors.length + statusValidationErrors.length) > 0 ?
            <Grid container className={classes.shiftInfo}>
                <Grid style={{ marginBottom: '10px' }} item xs={12}>
                    <Typography
                        component='h1'
                        className={classes.viewHeader}
                    >
                        Rule violations
                    </Typography>
                </Grid>
                <ValidationErrorPanel
                    validationErrorsResponse={validationErrors}
                    statusValidationErrorsResponse={statusValidationErrors}
                />
            </Grid> : null
        )
    }

    renderView = () => {
        const { formData, classes, updateMobileView, mobileView, updateSidePanelView, sidePanelData, t } = this.props
        const { showRetractConfirmation } = this.state;

        if (showRetractConfirmation) {
            const isRetractingRequest = formData.source === RequestSource.Requester ||
                (formData.status === RequestStatus.Submitted || formData.status === RequestStatus.Pending);

            const title = isRetractingRequest
                ? t("employeeSidePanel.retractPopup.retractRequest")
                : t("employeeSidePanel.retractPopup.retractOffer");

            const header = isRetractingRequest
                ? t("employeeSidePanel.retractPopup.headerRequest")
                : t("employeeSidePanel.retractPopup.headerOffer");

            return (
                <div className="comment-to-manager-container ">
                    <ConfirmWithMessageContent
                        title={title}
                        header={header}
                        showTextField={false}
                        onCancel={this.hideRetractConfirmation}
                        onConfirm={this.handleConfirmRetract}
                    />
                </div>
            );
        }

        let selectedShift, job;
        const button = this.generateSidePanelSubmitButtons();

        switch (formData.type) {
            case -1: // Shift offer
                selectedShift = formData.shifts[0]
                job = selectedShift.segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT).shortOrgJobPath
                const filteredManagerSettings = this.filterManagerSettings();

                return (
                    <React.Fragment>
                        <Grid item xs={12} className={classes.shiftInfo}>
                            <Typography variant={'h5'} className={classes.viewHeader}>{formatAs(selectedShift.startDateTime, DateFnsFormats.VERBOSE_LONG_DATE_WITH_DAY)}</Typography>
                            <Typography variant={'h6'}>{`${selectedShift.label ?? ""} ${getAsStartAndEndTimeFormat(selectedShift.startDateTime, selectedShift.endDateTime)}`}</Typography>
                            <Typography variant={'subtitle2'} style={{ fontWeight: 300 }}>{job}</Typography>
                        </Grid>
                        <Grid item xs={12} style={{ padding: '10px 15px' }}>
                            <ReactSelect
                                labelText={t('billboard.selectRequestType')}
                                placeholder={t('billboard.selectRequestType')}
                                value={formData.managerSetting}
                                options={filteredManagerSettings.map(setting => { return { ...setting, label: setting.name, value: setting.id } })}
                                onChange={this.handleSelectManagerSetting}
                                target={'managerSetting'}
                                classes={classes}
                            />
                        </Grid>
                        {this.renderSegments(selectedShift)}
                        <AvailableTimeOffRequest
                            timeOffRequest={sidePanelData.timeOffRequest}
                            error={sidePanelData.timeOffRequestError}
                        />
                        <Grid container className={classes.bottomBar}>
                            <Grid item xs={12} style={{ padding: '5px' }}>
                                {button}
                            </Grid>
                        </Grid>
                    </React.Fragment>
                );
            case RequestTypes.toCover:
                selectedShift = formData.raw.isPartial ? formData.raw.partialShift : formData.shifts[0]
                job = selectedShift.segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT).shortOrgJobPath
                let startDate = selectedShift.startDateTime
                let endDate = selectedShift.endDateTime
                return (
                    <React.Fragment>
                        {this.renderOfferOwnership(formData.raw.employeeFromName)}
                        <Grid item xs={12} className={classes.shiftInfo}>
                            <Typography variant={'h5'} className={classes.viewHeader}>{formatAs(startDate, DateFnsFormats.VERBOSE_LONG_DATE_WITH_DAY)}</Typography>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {formData.partialDates.isPartial ? <PartialIcon /> : null}
                                <Typography component={'div'} style={{ padding: '0 5px' }} variant={'h6'}>{`${formData.shifts[0].label ?? ''} ${getAsStartAndEndTimeFormat(startDate, endDate)}`}</Typography>
                            </div>
                            <Typography variant={'subtitle2'} style={{ fontWeight: 300 }}>{job}</Typography>
                        </Grid>
                        {this.renderSegments({ ...selectedShift, partialDetail: formData.partialDates })}
                        {this.renderValidationDetails()}
                        {this.renderRecipients()}
                        {this.renderHistory()}
                        {this.renderDetails()}
                        {formData.status === RequestStatus.Offered && formData.source === RequestSource.Requester
                            ? this.renderValidAssignmentSelect()
                            : null}
                        <Grid container className={button && classes.bottomBar}>
                            <Grid item xs={12} style={{ padding: '5px' }}>
                                {this.generateSidePanelSubmitButtons()}
                            </Grid>
                        </Grid>
                    </React.Fragment >
                )
            case RequestTypes.shiftSwap: {
                const isPartial = formData.raw.isPartial;
                const shiftsInOffer = isPartial ? [formData.raw.partialShift] : formData.shifts;
                job = shiftsInOffer[0].segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT).shortOrgJobPath;
                let proposals = null;
                let isRenderRecipients = false;
                if (formData.source === RequestSource.Requester) { //avail offers, my proposals, 
                    if (formData.proposals && formData.proposals.length > 0) {
                        const lastProposal = formData.proposals[formData.proposals.length - 1];
                        const proposalShifts = lastProposal.isPartial ? [lastProposal.partialShift] : lastProposal.shifts;
                        proposals = this.shiftBuilder(proposalShifts, 'Shift(s) proposed', "proposed", lastProposal.isPartial)
                    }
                }
                else { //my swap offers
                    isRenderRecipients = true;
                    if (formData.proposals && formData.proposals.length > 0) {
                        if (formData.isProposedByOfferer) {
                            proposals =
                                <Grid item xs={12} className={classes.shiftInfo}>
                                    <ProposalCard
                                        hasActions={false}
                                        proposals={formData.proposals
                                            .map(ele => formatProposalDataWithCustomName(ele, formData.raw.offerorEmployeeName))
                                        }
                                    />
                                </Grid>
                        }
                        else {
                            const isOfferedOrSubmitted = formData.status === RequestStatus.Offered || formData.status === RequestStatus.Submitted;
                            const proposalsToShow = isOfferedOrSubmitted
                                ? formData.proposals.filter(p => p.status === formData.status)
                                : [];

                            proposals =
                                <Grid item xs={12} className={classes.shiftInfo}>
                                    <ProposalCard
                                        hasActions={formData.status === RequestStatus.Offered}
                                        proposals={proposalsToShow.map(ele => formatProposalData(ele, formData.offerId))}
                                        handleAcceptButton={(proposalId) => {
                                            this.handleSelectUpdateForm('proposalIdSelected', proposalId);
                                            updateSidePanelView('CommentToManager');
                                        }}
                                        handleRejectButton={(proposalId) => {
                                            handleRejectProposal(this, proposalId, formData)
                                            updateMobileView(mobileView.previous)
                                        }} />
                                </Grid>
                        }
                    }
                }

                return (
                    <React.Fragment>
                        {this.renderOfferOwnership(formData.raw.offerorEmployeeName)}
                        <Grid item xs={12}>
                            {this.shiftBuilder(shiftsInOffer, 'Shift(s) offered', "offered", isPartial)}
                        </Grid>
                        <Grid item xs={12}>
                            {proposals}
                        </Grid>
                        {this.renderValidationDetails()}
                        {this.renderPreferredDates()}
                        {isRenderRecipients && this.renderRecipients()}
                        {this.renderHistory(formData.history)}
                        {this.renderDetails()}
                        <Grid container className={button && classes.bottomBar}>
                            <Grid item xs={12} style={{ padding: '5px' }}>
                                {this.generateSidePanelSubmitButtons()}
                            </Grid>
                        </Grid>
                    </React.Fragment>
                );
            }
            case RequestTypes.openShift:
                selectedShift = formData.raw.isPartial ? formData.raw.partialShift : formData.shifts[0];
                job = selectedShift.segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT).shortOrgJobPath;

                const submissionStartDate = formData?.submissionPeriod?.startDate ? getAsLongDateTime(formData?.submissionPeriod?.startDate) : null;
                const submissionEndDate = formData?.submissionPeriod?.endDate ? getAsLongDateTime(formData?.submissionPeriod?.endDate) : null;
                return (
                    <React.Fragment>
                        <Grid item xs={12} className={classes.shiftInfo}>
                            <Typography variant={'h5'} className={classes.viewHeader}>{formatAs(selectedShift.startDateTime, DateFnsFormats.VERBOSE_LONG_DATE_WITH_DAY)}</Typography>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {formData.partialDates.isPartial ? <PartialIcon /> : null}
                                <Typography style={{ padding: '0 5px' }} variant={'h6'}>{`${formData.shifts[0].label ?? ''} ${getAsStartAndEndTimeFormat(selectedShift.startDateTime, selectedShift.endDateTime)}`}</Typography>
                            </div>
                            <Typography variant={'subtitle2'} style={{ fontWeight: 300 }}>{job}</Typography>
                        </Grid>
                        {this.renderSegments(selectedShift)}
                        {this.renderValidationDetails()}
                        {this.renderAssignmentSelector()}
                        <Grid item xs={12} className={classes.segments}>
                            <SidePanelDetails
                                isShowManagerMessage
                                managerMessage={formData.details}
                                isShowSubmissionPeriod={!!formData.submissionPeriod}
                                submissionStartDate={submissionStartDate}
                                submissionEndDate={submissionEndDate}
                            />
                        </Grid>
                        {this.renderHistory()}
                        <Grid container className={button && classes.bottomBar}>
                            <Grid item xs={12} style={{ padding: '5px' }}>
                                {this.generateSidePanelSubmitButtons()}
                            </Grid>
                        </Grid>
                    </React.Fragment >
                )
            case RequestTypes.voluntaryTimeOff:
                return (
                    <React.Fragment>
                        {generateVTOInformation.bind(this)(classes, formData)}
                        <Grid container className={button && classes.bottomBar}>
                            <Grid item xs={12} style={{ padding: '5px' }}>
                                {this.generateSidePanelSubmitButtons()}
                            </Grid>
                        </Grid>
                    </React.Fragment>

                )
            default:
                return (null)
        }

    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    render() {
        const { classes } = this.props
        return (
            <Grid container className={classes.shiftDetail}>
                {this.renderView()}
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    return {
        classes: MOBILE_SIDEPANEL_CLASSES,
        storeData: state.data,
        formData: state.mobileOfferShiftForm,
        managerSettings: state.managerSettings,
        person: state.person,
        options: state.httpOptions,
        mobileView: state.mobileView,
        managerSettingNames: state.managerSettingNames,
        statusDictionary: state.statusDictionary,
        dateRanges: state.dateRanges,
        sidePanelData: state.sidePanelData,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateMobileView: payload => dispatch(updateMobileView(payload)),
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
        updateLoading: payload => dispatch(updateLoading(payload)),
        updateSnackbar: payload => dispatch(updateSnackbar(payload)),
        clearMobileOfferForm: () => dispatch(clearMobileOfferForm()),
        updateEmployeeDashboardData: payload => dispatch(updateEmployeeDashboardData(payload)),
        updateSidePanelData: (payload) => dispatch(updateSidePanelData(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(ShiftDetails))